/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import CodesPage from '/client/src/pages/Events/detail/codes';
import SaveBtn from '../saveBtn';
import { withRouter } from 'react-router-dom';
import { ToggleLeftMenu } from '/client/src/utils/animation';
import { GET } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';

type NewDesignPropsType = {
  onHandleChangeStepNavBar: () => void,
  match: {
    params: {
      eventId?: string | number,
      viewTab?: string
    }
  }
};

class NewShare extends React.Component<NewDesignPropsType> {
  props: PropsType;

  state = {
    eventDetail: null,
    isForceRefresh: false
  };

  componentDidMount() {
    ToggleLeftMenu('hide');

    this.handleLoad();
  }

  componentWillUnmount() {
    ToggleLeftMenu('show');
  }

  handleLoad = async () => {
    const { match: { params } } = this.props;

    try {
      CssPinner(document.body, true);
      NProgressCustom(true);
      const { result } = await GET(`/api/v1/1/events/${params.eventId}/detail`);

      this.setState({
        eventDetail: result
      }, () => {
        CssPinner(document.body, false);
        NProgressCustom(false);
      });
    } catch (e) {
      console.log(e);
      CssPinner(document.body, false);
      NProgressCustom(false);
    }

    this.setState({
      isForceRefresh: true
    });
  };

  render(): React.Element<'div'> {
    const { match: { params }, onHandleChangeStepNavBar } = this.props;

    return (
      <>
        <div className="splash-create-tip">
          <h2>Wow your fans!</h2>
          <p>
            Here are some ways to create a powerful experience for your customers!
            Check out these beautiful integrations!
          </p>
        </div>
        <CodesPage {...this.props} _eventDetail={this.state.eventDetail} isNew />

        {this.state.isForceRefresh &&
          <SaveBtn
            handleSave={() => {
              this.props.history.push('/');
            }}
            onHandleChangeStepNavBar={onHandleChangeStepNavBar}
            isNew={params.viewTab !== 'edit'}
            text={params.viewTab === 'edit' ? 'Save' : 'Done'}
          />
        }
      </>
    );
  }
}

export default withRouter(NewShare);
